import React, {useState} from "react";
import {Button} from "antd";
import {useStore} from "../../../../../hooks/useStore";
import {DownloadOutlined} from "@ant-design/icons";

const CourierAllDocumentsDownload = ({courierId, hasAnyDocument}) => {
    const [loading, setLoading] = useState(false);
    const stores = useStore();

    const handleDownload = async () => {
        try {
            setLoading(true);
            const result = await stores.courierStore.downloadAllDocuments(courierId);

            if (!result || !result.base64Data) {
                stores.appStore.openErrorModal({content: "Belge indirilemedi"});
                return;
            }

            const dataUrl = `data:${result.mimeType};base64,${result.base64Data}`;

            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = result.fileName || "documents.zip";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            stores.appStore.openErrorModal({content: error.message});
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            type="primary"
            shape="round"
            size="middle"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            disabled={loading || !hasAnyDocument}
            style={{margin: "16px 0"}}
        >
            {loading ? "İndiriliyor..." : "Tüm Belgeleri İndir"}
        </Button>
    );
};

export default CourierAllDocumentsDownload;
